export default __webpack_public_path__ + "static/media/mobile-wallets.6c5ac55a.jpg";